import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import { Queries, Mutations } from '../../../../../graphql'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, Radio, DatePicker, Avatar, Modal, InputNumber } from 'antd'
import { checkDisbledInput, setSummaryTotal, checkStatus } from '../../../../../utils/hospital'
import { numberWithCommas } from '../../../../../utils/number'
import { changeFormatdate, changeFormatFulldate } from '../../../../../utils/formatdate'
import ModalshowAllImage from '../../../ModalshowAllImage/update'
import moment from 'moment'
const { Text, Title } = Typography

class TableMedicalCertificateUpdate extends Component {
	state = {
		dataTable: [],
        columns: [
            {
                title: ()=>{
                    return <span>รายละเอียดเพิ่มเติม </span>
                },
                dataIndex: 'descriptionMedicalCertificate',
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return(
                        <>
                            <Form.Item label={""}>
                                { this.props.form.getFieldDecorator("descriptionMedicalCertificate"+index, {
                                    initialValue: item,
                                    rules:  [{ 
                                        // required: record.statusFile ? true : false, 
                                        // required: true, 
                                        message: 'กรุณากรอกรายละเอียดใบรับรองแพทย์',
                                    }],
                                })(
                                    <Input 
                                        // defaultValue={item} 
                                        disabled={ this.checkDisbledInputDocument(record) }
                                        onBlur={ (e) => this.onChangeValueForm(index, e, 'descriptionMedicalCertificate') }
                                    />
                                )}
                            </Form.Item>
                        </>
                    )
                }
            },
            {
                title: ()=>{
                    return <span>เอกสารแนบ </span>
                },
                dataIndex: '7',
                width:200,
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return (
                        <>
                           {/* { this.inputFormUploadsDocument(index) } */}
                           { this.inputFormUploadsDocument(index) }
                            { this.showMoreFileUploads(index, 'Doc') }
                        </>
                    )
                }
            },
            {
                title: ()=>{
                    return <span>จัดการ</span>
                },
                dataIndex: '7',
                width:20,
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return this.showDetailBtnInputDocument(record, index)
                }
            },
        ],
        ModalshowAllImageVisible: false,
        ModalshowAllImageTitle:null,
        ModalshowAllImageData:[],
        ModalshowAllImageArrayId:null,
        ModalshowAllImageDatabase: true,
        ModalTypeUpload: '',
	}

    checkDisbledInputDocument = (record) =>{
        const { statusForm } = this.props
    
        console.log('statusForm',statusForm)
        if(statusForm == 'canEdit'){
            return record.wdHospitalDocumentId ? checkDisbledInput(statusForm, "descriptionMedicalCertificate") ? true : false : false 
        }else{
            return true
        }
        // return
    }

    destroyArrayDataImages =  async (arrayId, arraySpliceFileName, arrayFileId) =>{
        const { ModalTypeUpload } = this.state
        const { setDataTableMedicalCertificate } = this.props
        let indexKey = null

        if(ModalTypeUpload == 'Doc'){
            var arrayDataSource = [...this.state.dataTable];
            arrayDataSource[arrayId].file.map(( values, keys ) =>{
                if(arraySpliceFileName){
                    if(values.name == arraySpliceFileName){
                        indexKey = keys
                    }
                }else{
                    if(values.idFile == arrayFileId){
                        indexKey = keys
                    }
                }
            })
            
            arrayDataSource[arrayId].file.splice(indexKey, 1);
            
            await this.setState({
                dataTable:arrayDataSource,
                // ModalshowAllImageData: arrayDataSource[arrayId].file
            },async() => {
                if(arrayDataSource[arrayId].file.length == 0) {
                    await this.setState({
                        ModalshowAllImageVisible: false
                    })
                }

                await setDataTableMedicalCertificate(this.state.dataTable, arrayFileId)
            })
        }
    }

    ModalshowAllImageShow = async (data, title, arrayId, imageDatabase, modalTypeUpload)=>{
        await this.setState({
            ModalshowAllImageVisible: true,
            ModalshowAllImageTitle: title,
            ModalshowAllImageData: data,
            ModalshowAllImageArrayId: arrayId,
            ModalshowAllImageDatabase: imageDatabase,
            ModalTypeUpload : modalTypeUpload
        })
    }


    ModalshowAllImageHide = async () =>{
        await this.setState({
            ModalshowAllImageVisible: false,
            ModalshowAllImageTitle: null,
            ModalshowAllImageData: [],
            ModalshowAllImageArrayId: null,
            ModalshowAllImageDatabase: false
        })
    }

    
    inputFormUploadsDocument = (arrayId) =>{
        const { statusForm } = this.props
        const { dataTable } = this.state
        return(
            <>
                {
                    statusForm == 'canEdit' ?
                        <>
                            <label for={"input-fileMedicalCertificate-"+arrayId} class="custom-file-upload">
                                <p className="py-2 px-4" align={"center"} style={{ backgroundColor:"#8d0e14", color:"#fff" }}>
                                    {/* อัปโหลด */}
                                    อัปโหลด +
                                </p>
                                <p style={{ fontSize:"12px" }} className="my-2">แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf</p>
                            </label>
                            <input
                                id={"input-fileMedicalCertificate-"+arrayId}
                                className="input-file"
                                multiple
                                // name={uploadName}
                                type="file"
                                // accept="file_extension"
                                accept="image/png, image/jpeg, application/pdf"
                                // rules={ true }
                                onChange={e => this.handleAdd(e.target.files,arrayId)}
                                // onChange={e => console.log(e.target.files)}
                            />
                        </>
                    :
                        ''
                }
            </>
        )
    }

    handleAdd = async (images, arrayId ) => {
        const { dataTable, reqAttachDayStatus } = this.state
        const { setDataTableMedicalCertificate } = this.props
        if(images){
            let dataSourceitems = [...this.state.dataTable];
            let item = {...dataTable[arrayId]};

            item.file.push(...images)

            item = {
                wdHospitalDocumentId: item.wdHospitalDocumentId ? item.wdHospitalDocumentId : null,
                statusFile: item.documentType == 'อื่น ๆ' ? true : false,
                descriptionMedicalCertificate: item.descriptionMedicalCertificate,
                file: item.file,
            }
            dataSourceitems[arrayId] = item;

            await this.setState(({
                dataTable: dataSourceitems,
            }), async () => {
                document.getElementById('input-fileMedicalCertificate-'+arrayId).value = [];
                await setDataTableMedicalCertificate(dataSourceitems)
                // this.cllBackSetValueOrganizatuions()
            })
        }
	}

    showMoreFileUploads = (arrayId, uploadFile) =>{
        const { dataTableUploads, dataTable } = this.state
        let fileName = null
        let fileNameShow = null

    
        // if(dataTable[arrayId].wdHospitalDocumentId){
        //     return <>
        //                 {
        //                     dataTable[arrayId].fileData.length !== 0 &&
        //                         <p 
        //                             onClick={ () => { this.ModalshowAllImageShow(dataTable[arrayId].fileData, 'ไฟล์อัปโหลดเอกสารใบรับรองแพทย์', arrayId, true, uploadFile) }} 
        //                             style={{ cursor:"pointer" }}
        //                             className="btn-show-fileuploads"
        //                         >
        //                             ดูไฟล์อัปโหลด
        //                         </p>
        //                     ||
        //                         ''
        //                 }
        //             </>
        // }else if(dataTable[arrayId].file.length !== 0){
        if(dataTable[arrayId].file.length !== 0){
            return  <>
                        <p 
                            onClick={ () => { this.ModalshowAllImageShow(dataTable[arrayId].file, 'ไฟล์อัปโหลดเอกสารใบรับรองแพทย์', arrayId, false, uploadFile) }} 
                            style={{ cursor:"pointer" }}
                            className="btn-show-fileuploads"
                        >
                            ดูไฟล์อัปโหลด
                        </p>
                    </>
        }else{
            return <span id={"showTextUplodasHospital"+arrayId}>กรุณาแนบใบรับรองแพทย์ อย่างน้อย 1 ฉบับ</span>
        }
    }

    deleteAttachmentFile = async (wdHospitalDocumentId, arrayId) =>{
        const { form, afterSubmit, client, match } = this.props
        try {
            const { data, errors } = await client.mutate({
                mutation: Mutations.destroyWDHospitalDocument,
                variables: {
                    wdHospitalDocumentId,
                }
            })

            if(data){
                message.success("ลบรายการเอกสารใบรับรองแพทย์เรียบร้อย")
                await this.destroyArrayDataUploads(arrayId)
                // setTimeout(() => {
                //     window.location.reload();
                // }, 600);
            }
        }catch (error) {
            
        }
    }

    showDetailBtnInputDocument = (record, arrayId) =>{
        const { dataTable } = this.state
        const { statusForm } = this.props
        return(
            <>
                {
                    statusForm != 'canEdit' ?
                            <Avatar 
                                disabled={true}
                                shape="square"  
                                icon={<Icon type="delete" />} 
                                className="mr-1 mb-1"  
                                // onClick={ () => this.destroyArrayDataUploads(arrayId) }
                                style={{ cursor: 'not-allowed' }}
                            />
                    :
                    <>
                        {
                            record.wdHospitalDocumentId ?
                                <Popconfirm
                                    placement="topRight"
                                    title={"คุณต้องการที่จะลบไฟล์"}
                                    onConfirm= { () => this.deleteAttachmentFile(dataTable[arrayId].wdHospitalDocumentId, arrayId) }
                                    okText="ตกลง"
                                    cancelText="ยกเลิก"
                                >
                                    <Avatar 
                                        shape="square"  
                                        icon={<Icon type="delete" />} 
                                        className="mr-1 mb-1 bg-red"  
                                        style={{ cursor: 'pointer', background:"red" }}
                                    />
                                </Popconfirm>
                                :  
                                    <Avatar 
                                        shape="square"  
                                        icon={<Icon type="delete" />} 
                                        className="mr-1 mb-1 bg-red"  
                                        onClick={ () => this.destroyArrayDataUploads(arrayId) }
                                        style={{ cursor: 'pointer', background:"red" }}
                                    />
                        }
                    </>
                                    
                }
               
            </>
        )
    }

    onChangeValueForm = async (arrayId, values, name) =>{
        const { dataTable } = this.state
        const { setDataTableMedicalCertificate } = this.props
        let dataSourceitems = [...this.state.dataTable];
        let item = {...dataSourceitems[arrayId]};

        if(name == 'descriptionMedicalCertificate'){
            item.descriptionMedicalCertificate = values.target.value
        }else if(name == 'documentType'){
            item.documentType = values
            item.statusFile = values == 'อื่น ๆ' ? true : false
        }

        dataSourceitems[arrayId] = item;


        await this.setState({
            dataTable:dataSourceitems
        },async () => {
            await setDataTableMedicalCertificate(dataSourceitems)
        })
    }


    showDataInputUploadsDocument = async () =>{
        const { dataTable, reqAttachDayStatus } = this.state
        const { setDataTableMedicalCertificate } = this.props
        const rows = {
            wdHospitalDocumentId: null,
            documentType: null,
            statusFile: false,
            descriptionMedicalCertificate: null,
            file: [],
        }
        await this.setState(prevState => ({
            dataTable: [...prevState.dataTable, rows],
        }), async () => {
            await setDataTableMedicalCertificate(this.state.dataTable)
        })
    }

    destroyArrayDataUploads =  async (arrayId) =>{
        const { dataTable } = this.state
        const { setDataTableMedicalCertificate } = this.props
        var arrayDataSource = [...this.state.dataTable];
		arrayDataSource.splice(arrayId, 1);

		await this.setState({
			dataTable:arrayDataSource,
            // dataTableLength: lengthData
		},async() => {

            arrayDataSource.map(async (valuesTable, keysTable) =>{
                let description = `description${keysTable}`
                // "documentType"+index
                await this.props.form.setFieldsValue({
                    [description]: valuesTable.description,
                })
            })

            await setDataTableMedicalCertificate(arrayDataSource)
			// this.cllBackSetValueContactNumber()
		})
    }

	async componentDidMount() {
        const { dataTableMedicalCertificate } = this.props
        if (dataTableMedicalCertificate.length !== 0) {
            let dataTable = []
            await dataTableMedicalCertificate.map((valuesFile , keyValuesFile) =>{
                let dataArray = {
                    wdHospitalDocumentId: valuesFile.wdHospitalDocumentId,
                    descriptionMedicalCertificate: valuesFile.description ? valuesFile.description : '',
                    description: valuesFile.description ? valuesFile.description : '',
                    fileData: valuesFile.fileData,
                    idFile: valuesFile.idFile,
                    file: valuesFile.fileData,
                }
                dataTable.push(dataArray)
            })
            await this.setState({
                dataTable,
            })
        }
    }

	render() {
		const {
            columns,
            dataTable,
            preLoadOnsubmit,
            ModalshowAllImageVisible,
            ModalshowAllImageTitle,
            ModalshowAllImageData,
            ModalshowAllImageArrayId,
            ModalshowAllImageDatabase,
        } = this.state
        const { statusForm } = this.props

        return (
                <>
                    <ModalshowAllImage
                        title={ModalshowAllImageTitle} 
                        showModal={ModalshowAllImageVisible}
                        data={ModalshowAllImageData}
                        hideModal={ this.ModalshowAllImageHide }
                        dataArrayId={ ModalshowAllImageArrayId }
                        destroyArrayDataImages = { this.destroyArrayDataImages }
                        imageDatabase = {ModalshowAllImageDatabase}
                        ModalTypeUpload = {"Medical"}
                        statusForm={statusForm}
                    />
                    <Col xs={24} md={24} className="pt-2 mb-3">
                        <strong className="color-red">
                            เอกสารใบรับรองแพทย์
                        </strong>
                    </Col>
                    <Col xs={24} md={24} align={"right"} >
                        <Table
                            locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                            columns={columns}
                            dataSource={dataTable}
                            pagination={false}
                            className="mb-3"
                            bordered
                            // rowCount={dataTable.length}
                            // pagination={{ pageSize: dataTable.length }}
                            // pagination={{ pageSize: false }}
                        />
                        <Button 
                            style={{ display:"inline-block" }}
                            type="primary btn-color-default btn-custom btn-clear color-white" 
                            className="mt-1 mr-2"
                            onClick={ () => this.showDataInputUploadsDocument() }
                            disabled={ checkDisbledInput(statusForm, "btnPush") ? true : false }
                        >
                            เพิ่ม +
                        </Button>
                    </Col>
                </>
		)
	}
}

TableMedicalCertificateUpdate.defaultProps = {
	autoFocus: false
}

TableMedicalCertificateUpdate.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedTableMedicalCertificateUpdate = Form.create()(TableMedicalCertificateUpdate)

export default withApollo(WrappedTableMedicalCertificateUpdate)